import $ from "jquery";

var languageCode = $("html").attr("lang");
var translations = {
  es: {
    "Please wait...": "Por favor espere...",
    "Uploading data ": "Subiendo datos ",
    Required: "Obligatorio",
    "File upload in progress. Are you sure you want to stop the file upload?":
      "Se esta subiendo un archivo. ¿Esta seguro de querer detener esta operación?",
  },
  fr: {
    Required: "Obligatoire",
  },
};

/**
 * @short Translation function.
 *
 * It needs two preious init calls:
 *
 *  addTranslations(trans) - A dict like this {'es':{'hello':hola},'fr':{'hello':'alo'}},
 *                           may be called several times
 *
 *  setLanguageCode(code) - the language code, like 'es'
 *
 * Allows an arbitrary number of arguments that will replace (as Strings) the {{1}}, {{2}}, {{3}}...
 */
var _ = function () {
  //alert(languageCode)
  var s = arguments[0];
  ns = s;
  try {
    ns = translations[languageCode][s];
    if (!ns) ns = s;
  } catch (e) {
    ns = s;
  }

  // Now substitutions
  for (i = 1; i < arguments.length; i++) {
    ns = ns.replace("{{" + i + "}}", String(arguments[i]));
  }
  return ns;
};

_.setLanguageCode = function (code) {
  languageCode = code;
  _.languageCode = code;
};

_.addTranslations = function (trans) {
  for (var lang in trans) {
    if (!translations[lang]) translations[lang] = {};
    for (var orig in trans[lang]) {
      translations[lang][orig] = trans[lang][orig];
    }
  }
};
_.translations = translations;

// 	_.changeLanguage = function(lang){
// 		$('#lang [name=language]').val(lang)
// 		$('#lang').submit()
// 	}

export default _;
